<template>
  <div class="head-div">
    <el-header class="head-div">
      <el-carousel :height="bannerHeight + 'px'">
        <el-carousel-item v-for="item in head_img_list" :key="item">
          <img :src="item" alt />
        </el-carousel-item>
      </el-carousel>

      <div class="querykeybar">
        <el-row type="flex" justify="center" class="pt15">
          <el-select class="querykey-type" v-model="selectSearchType" placeholer="请选择" @change="changeSearchType" value-key="value">
            <el-option v-for="(item,index) in searchTypeList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"></el-option>
          </el-select>
          <el-input class="querykey-input" v-model="editSearchKeyWord" placeholder="请输入关键字" @change="changeEditSearchKeyWord"></el-input>
          <el-button class="querykey-button" icon="el-icon-search" @click="clickKeyWordQuery">检索</el-button>
        </el-row>
        <div type="flex" justify="center" class="querykey-word-div">
            <span v-for="item in searchKeyList" v-bind:key="item.id" class="querykey-word"><a @click="clickHistoryKeyword(item.searchKeyword)"> {{item.searchKeyword}}</a></span>
        </div>
     </div>

      

    </el-header>
  </div>
</template>

<script>
import {Message} from "element-ui";
import searchkeyApi from "@/api/searchkey"
import index_banner1 from '@/assets/site-image/banner.jpg'
import index_banner2 from '@/assets/site-image/banner1.jpg'

export default {
  name: "headBanner",
  data(){
    return{
      headHeight: 240,
      bannerHeight: 240,
      searchKeyList: [],
      selectSearchType: 0,
      editSearchKeyWord: '',
      head_img_list: [index_banner1,index_banner2],
      appData: {
        title: "gary column title.",
      },
      queryEntity:{
        keyword: '',
        current: 1,
        pages: null,
        sizes: 6,
        total: 0,
        extInt:1,
        orderField: "resourceType",
      },
      searchTypeList: [
          {value: 0, label: "全部"},
          {value: 1, label: "标题"},
          {value: 2, label: "著者"},
          {value: 3, label: "出版地"},
        ],
    }
  },
  props: {
      searchPara: {
        type: [Object],
      }
    },
  created() {
    this.initData()
  },
  mounted(){
    console.log('search para category : ',this.searchPara.categoryCode)
  },
  methods:{
    initData(){
      this.getSearchKeyList()
    },
    changeSearchType(selectItem){
        this.selectSearchType = selectItem;
    },
    getSearchKeyList(){
      let queryPara = {
        keyword: null,
        sizes: 10,
        current: 1,
        extInt: null,
      }
      searchkeyApi.getTopSearchKeywordList(queryPara).then(res => {
        if (res!=null && res.data!=null){
          this.searchKeyList = res.data.data;
          this.tableLoading = false;
        }
      })
    },
    changeEditSearchKeyWord(){
      this.inputKeyWord = this.editSearchKeyWord;
    },
    clickKeyWordQuery(){
      if (this.inputKeyWord!=null && this.inputKeyWord.trim()!=''){
        this.inputKeyWord = this.editSearchKeyWord;
        //this.selectSearchType = 0
        this.$emit('clickSearchData',this.selectSearchType,this.inputKeyWord,this.searchPara.categoryCode)
      }else{
        Message.info("请输入要检索的关键字。");
      }
    },
    clickHistoryKeyword(keyword){
      if (keyword!=null && keyword.trim()!=''){
        //this.selectSearchType = 0
        this.$emit('clickSearchData',this.selectSearchType,keyword,this.searchPara.categoryCode)
      }else{
        Message.info("请输入要检索的关键字。");
      }
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .head-div{
    height: 240px;
    width: 1400px;
    margin:0;
    padding:0;
    border:0;
  }
  .querykeybar{
    width: 600px;
    margin-top: -80px;
    height: 80px;
    line-height: 30px;
    vertical-align: middle;
    align-content: flex-end;
    float: right;
    z-index: 100;
    position: absolute;
    margin-left: 600px;
  }
  .querykey-start{
    width: 5%;
  }
  .querykey-word-label{
    height: 50px;
    margin-right: 20px;
    vertical-align: middle;
    display:inline-block;
    line-height:50px;
    white-space: nowrap;
    font-size: 16px;
    color:#000000;
  }
  .querykey-word{
    height: 30px;
    margin-left: 10px;
    vertical-align: middle;
    display:inline-block;
    line-height:30px;
    white-space: nowrap;
    font-size: 14px;
    color:#000000;
  }

  .querykey-word-div{
    margin-left: 75px;
    margin-top:-6px;
    width: 450px;
    display:inline-block;
    font-size: 1.2rem;
    position: absolute;
    white-space: nowrap;
  }
  .querykey-type{
  margin-top: 6px;
  margin-right: 10px;
  width: 150px;
  /* min-height: 30px; */
  height: 35px;
}

  .querykey-input{
    margin-top: 6px;
    width: 450px;
    // min-height: 30px;
    height: 35px;
  }
  .querykey-button{
    margin-top: 5px;
    margin-left: 10px;
    margin-right: 20px;
    height: 35px;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/view/template/head.vue